interface INormalizeOptions {
    removeWhiteSpace?: boolean;
}

/**
 * @param string - the string to clean
 * @param toRemove - an array of patterns to remove
 * @param options - additional options for pattern matching
 */
export const normalizeString = (
    string: string,
    toRemove: string[],
    options: INormalizeOptions = { removeWhiteSpace: false }
) => {
    // combines all patterns to be removed into a single RegexExp and adds trailing white space pattern if needed
    const pattern = toRemove
        .map((str) => str + `${options.removeWhiteSpace ? `\\s*` : ``}`)
        .join(`|`);
    const regex = new RegExp(pattern, `g`);

    if (string) {
        return string.replaceAll(regex, ``);
    }
};
